/**
 * Domain representation of an approver's decision on a time-off request.
 * Mapped to {@link TimeOffReviewDecisionDTO} before hitting the API.
 */
export enum TimeOffReviewDecision {
  Approve = 'approve',
  Decline = 'decline',
}
